import { SelectRoot } from './select'
import { SelectGroup } from './select-group'
import { SelectItem } from './select-item'
import { SelectLabel } from './select-label'
import { SelectSeparator } from './select-separator'

export const Select = Object.assign(SelectRoot, {
  Item: SelectItem,
  Group: SelectGroup,
  Label: SelectLabel,
  Separator: SelectSeparator,
})
